// angular
// 	.module("HeroPRO")
// 	.directive('hpPipelineStageIndicator', pipelineStageIndicator);

import _ from 'lodash';
import './pipelineStageIndicator.scss';

/* @ngInject */
export default function pipelineStageIndicator(HPPipelineStages, FRInformationFactory) {
    const stageIndicatorLink = (scope) => {
        scope.stages = [];
        _.each(HPPipelineStages, (val) => {
            scope.stages.push(val);
        });
        scope.stageList = _.map(scope.stages, _.clone);
        if (scope.stage === null || scope.stage === undefined) {
            FRInformationFactory.getFundingRequestInformationPromise().then(() => {
                const stateMachineData = FRInformationFactory.getStateMachineData();
                if (stateMachineData.PipelineStageId === HPPipelineStages.GetPaid.pipelineStageId || stateMachineData.PipelineStageId === HPPipelineStages.Closed.pipelineStageId) {
                    // (ajt 8/8/2016) Use the FundingRequest pipeline stage id and not the loan stage id for GetPaid and Closed.
                    scope.currentStage = stateMachineData.FundingRequestPipelineStageId;
                } else {
                    // (ajt 8/8/2016) For all other pipeline stages, the use the loan stage id
                    scope.currentStage = stateMachineData.PipelineStageId;
                }
            });
        } else {
            _.delay(() => {
                scope.currentStage = scope.stage;
            });
        }
    };

    return {
        transclude: true,
        replace: true,
        restrict: 'E',
        scope: {
            stage: '@?',
        },
        templateUrl: 'app/appDetail/pipelineStageIndicator/pipelineStageIndicator.html',
        link: stageIndicatorLink,
    };
}



// WEBPACK FOOTER //
// ./src/app/appDetail/pipelineStageIndicator/hpPipelineStageIndicator.js